module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', {
    staticClass: "why",
    class: {
      'why--active': _vm.whyActive
    },
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.why.bg + ')'
    }),
    attrs: {
      "id": "why"
    }
  }, [_c('div', {
    staticClass: "why__container"
  }, [_c('div', {
    staticClass: "why__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.why.title)
    }
  }), _c('div', {
    staticClass: "why__items-container"
  }, _vm._l((_vm.props.acf.why.items), function(item, i) {
    return _c('div', {
      staticClass: "why__items"
    }, [_c('Icon', {
      staticClass: "why__icon",
      class: 'why__icon--' + item.icon,
      attrs: {
        "name": item.icon
      }
    }), _c('div', {
      staticClass: "why__item-header",
      domProps: {
        "innerHTML": _vm._s(item.header)
      }
    }), _c('div', {
      staticClass: "why__item-text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)
  }))]), _c('div', {
    staticClass: "why__appt-btn",
    class: {
      'why__appt-btn--visible': _vm.whyActive
    }
  }, [_c('span', [_vm._v("Request Appointment")])]), _c('div', {
    staticClass: "why__arrow",
    on: {
      "click": function($event) {
        _vm.moveTo(5)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d88f1cb","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/sections/why/why.pug
// module id = 544
// module chunks = 1